import { AbstractControl, ValidatorFn } from '@angular/forms';

export function zipValidator(): ValidatorFn 
{
  return (control: AbstractControl): { [key: string]: any } | null => {
    let value = control.value

    if (typeof value !== 'string') 
    {
      return { required: true }
    }

    value = value.trim()

    if (value === '') 
    {
      return { required: true }
    }

    const valid = /^(?:\d{5}|(?:BP|CS|SP|CEDEX) \d{5})$/.test(value)
    return valid ? null : { invalidPostalCode: { value } }
  }
}
